import React from 'react';
import { PaymentMethod } from '@repo/payment-links-kit/constants';
import type { V4PaymentMethod } from '@repo/payment-links-kit/types';
import { IconApplePay } from '../../../assets/icons/icon-apple-pay.tsx';
import { IconBankTransfer } from '../../../assets/icons/icon-bank-transfer.tsx';
import { IconCreditCard } from '../../../assets/icons/icon-credit-card.tsx';
import { IconIdeal } from '../../../assets/icons/icon-ideal.tsx';
import { IconPaypal } from '../../../assets/icons/icon-paypal.tsx';
import { PaymentMethods } from '../../constants/payment-methods';

interface PaymentMethodIconProps {
  method: V4PaymentMethod | PaymentMethods;
  className?: string;
}

export function PaymentMethodIcon({ method, ...props }: PaymentMethodIconProps): React.ReactNode {
  if (method === PaymentMethods.ApplePay || method === PaymentMethod.ApplePay) {
    return <IconApplePay aria-hidden="true" {...props} />;
  }
  if (method === PaymentMethods.BankTransfer || method === PaymentMethod.BankTransfer) {
    return <IconBankTransfer aria-hidden="true" {...props} />;
  }
  if (method === PaymentMethods.CreditCard || method === PaymentMethod.CreditCard) {
    return <IconCreditCard aria-hidden="true" {...props} />;
  }
  if (method === PaymentMethods.Ideal || method === PaymentMethod.Ideal) {
    return <IconIdeal aria-hidden="true" {...props} />;
  }
  return <IconPaypal aria-hidden="true" {...props} />;
}
